<template>
  <section>
    <KpiCards
      class="mb-3"
      :items="kpiItems"
      :loading="loadingSummary"
      :skeleton="4"
    />

    <data-table
      :headers="headers"
      :items="category"
      commit="SET_CATEGORY"
      :viewItem="viewItem"
    >
      <div slot="activator" class="row justify-content-between mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
          <v-card-title class="px-0 pt-0 ps-products-title">
            {{ $t("category") }}
          </v-card-title>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 offset-lg-7">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
      </div>
    </data-table>

    <app-custom-dialog
      v-model="dialog"
      :footer="false"
      title="description"
    >
      <div slot="activator">
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="text-subtitle-1 font-weight-medium">
              {{ form.la_name }}
            </div>
            <div class="text-body-2 grey--text">{{ form.en_name || "-" }}</div>
          </v-col>
          <v-col cols="12" class="pt-0"><v-divider /></v-col>

          <v-col cols="4" class="grey--text">{{ $t("id") }}</v-col>
          <v-col cols="8" class="text-right font-weight-medium">{{
            form.id
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("name_th") }}</v-col>
          <v-col cols="8" class="text-right">{{ form.th_name || "-" }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("name_cn") }}</v-col>
          <v-col cols="8" class="text-right">{{ form.cn_name || "-" }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("qty_product") }}</v-col>
          <v-col cols="8" class="text-right">{{
            (form.products_count || 0) | NumberFormat
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("total_sales") }}</v-col>
          <v-col cols="8" class="text-right">{{
            (form.products_sale_sum_total_price || 0) | NumberFormat
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("date") }}</v-col>
          <v-col cols="8" class="text-right">{{ form.created_at | moment }}</v-col>
        </v-row>
      </div>
    </app-custom-dialog>

    <app-loading :overlay="overlay" />
  </section>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { productCategoryAdmin } from "@/utils/head";
import { myMixin } from "@/mixin/main";
import { adminStoreSummary } from "@/mixin/adminStoreSummary";

export default {
  mixins: [myMixin, adminStoreSummary],
  components: { DataTable },
  data: () => ({
    dialog: false,
    overlay: false,
    search: "",
    form: {},
  }),
  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummary("categories")]);
  },
  computed: {
    ...mapGetters({
      category: "index/category",
    }),
    headers() {
      return productCategoryAdmin(this);
    },
  },
  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchItem() {
      const { store_id } = this.$route.params;
      const body = {
        that: this,
        url: `get_shop_categories/${store_id}?q=${this.search}`,
        commit: "SET_CATEGORY",
      };
      await this.fetch(body);
    },
    viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
